import React from "react"
import PropTypes from "prop-types"
import PatientListItem from "../../PatientListItem"
import { withRouter } from '../../../lib/withRouter'
import { toggle, setAll } from "../../../redux/selection"
import { showSelectedOnly } from "../../../redux/settings"
import { setParam, fetch } from "../../../redux/query"
import store from "../../../redux"
import { connect } from "react-redux"
import Footer from "../../Footer"
import Header from "../../Header"
import ErrorMessage from "../../ErrorMessage"
import Alert from "../../Alert"
import "./Patients.less"
import AgeSelector from "../../AgeSelector"
import FhirSearchHeader from "../../FhirSearchHeader"
import ReactJson from "react-json-view"
import ViewHeader from "../ViewHeader"
import Header2 from "../../Header2"
import { getPath, getViewPatientData } from "../../../lib"
import PatientItem from "./PatientItem"
import Grid from "../../Fhir/Grid"
import PatientSidebar from "../PatientSidebar"
import AllergySidebar from "../AllergySidebar"
import DiagnosisSidebar from "../DiagnosisSidebar"

export class Patients extends React.Component {
    static propTypes = {
        query: PropTypes.object,
        selection: PropTypes.object,
        location: PropTypes.object,
        settings: PropTypes.object,
        urlParams: PropTypes.object,
        dispatch: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedPatient: null,
            selectedAllergy: null,
            selectedDiagnosis: null,
            patientListResult: null,
            diagnosisListResult: null,
            allergyListResult: null,
            leadsListResult: null,
            patientSearchTerm: "",
            diagnosisSearchTerm: null,
            allergySearchTerm: null,
            loading: false,
            error: null,
            // Pagination state
            currentPage: 1,
            hasNextPage: false, // Simple flag to indicate if next page exists
            pageSize: 10,
            activeTab: "patients" // Track active tab locally,

        };
    }

    /** Callback to handle tab changes from ViewHeader */
    handleTabChange = (tabName) => {
        this.setState({ activeTab: tabName });
        // Also update URL if needed
        this.props.dispatch(setParam("_resource", tabName));
    };

    componentDidMount() {
        // Set initial tab from URL
        const query = new URLSearchParams(this.props.location.search);
        const tab = query.get("_resource") || "patients";
        if (["patients", "diagnosis", "allergy", "leads"].includes(tab)) {
            this.setState({ activeTab: tab }, () => {
                // Fetch data after state is updated
                this.fetchDataForTab(tab);
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // Check if activeTab changed
        if (prevState.activeTab !== this.state.activeTab) {
            this.fetchDataForTab(this.state.activeTab);
        }
    }

    fetchDataForTab = (tab, page = 1) => {
        switch (tab) {
            case "patients":
                this.fetchPatientData(page);
                break;
            case "diagnosis":
                this.fetchDiagnosisData();
                break;
            case "allergy":
                this.fetchAllergyData();
                break;
            case "leads":
                this.fetchLeadsData(page);
                break;
            default:
                this.fetchPatientData(page);
        }
    };

    handleNextPage = () => {
        if (this.state.hasNextPage) {
            this.fetchDataForTab(this.state.activeTab, this.state.currentPage + 1);
            // this.fetchPatientData(this.state.currentPage + 1);
        }
    };

    handlePrevPage = () => {
        if (this.state.currentPage > 1) {
            this.fetchDataForTab(this.state.activeTab, this.state.currentPage - 1);
            // this.fetchPatientData(this.state.currentPage - 1);
        }
    };

    handlePageSizeChange = (e) => {
        const pageSize = parseInt(e.target.value);
        this.setState({ pageSize }, () => {
            this.fetchPatientData(1); // Reset to first page when page size changes
        });
    };

    fetchPatientData = async (page = 1) => {
        try {
            this.setState({ loading: true, error: null });

            let apiUrl = `${this.props.settings.server.url}/patient-list?page=${page}&size=${this.state.pageSize}`;

            if (this.state.patientSearchTerm) {
                apiUrl += `&mrn=${encodeURIComponent(this.state.patientSearchTerm)}`;
            }

            const data = await getViewPatientData({
                url: apiUrl,
                server: this.props.settings.server
            });

            const records = data?.records || [];
            const hasNextPage = records.length === this.state.pageSize; // If we got full page, assume there's more

            this.setState({
                patientListResult: records,
                loading: false,
                currentPage: page,
                hasNextPage: hasNextPage
            });
        } catch (error) {
            console.error("Search failed:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    fetchDiagnosisData = async () => {
        try {
            this.setState({ loading: true, error: null });

            let apiUrl = `${this.props.settings.server.url}/diagnosis-list`;
            if (this.state.diagnosisSearchTerm) {
                apiUrl += `?code=${encodeURIComponent(this.state.diagnosisSearchTerm)}`;
            }

            const data = await getViewPatientData({
                url: apiUrl,
                server: this.props.settings.server
            });


            this.setState({ diagnosisListResult: data || [], loading: false });
        } catch (error) {
            console.error("Search failed:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    fetchAllergyData = async () => {
        try {
            this.setState({ loading: true, error: null });

            let apiUrl = `${this.props.settings.server.url}/allergy-list`;
            if (this.state.allergySearchTerm) {
                apiUrl += `?code=${encodeURIComponent(this.state.allergySearchTerm)}`;
            }

            const data = await getViewPatientData({
                url: apiUrl,
                server: this.props.settings.server
            });


            this.setState({ allergyListResult: data || [], loading: false });
        } catch (error) {
            console.error("Search failed:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    fetchLeadsData = async (page = 1) => {
        try {
            this.setState({ loading: true, error: null });

            const apiUrl = `${this.props.settings.server.url}/lead?page=${page}&size=${this.state.pageSize}`;

            const data = await getViewPatientData({
                url: apiUrl,
                server: this.props.settings.server
            });

            const records = data?.records || [];
            const hasNextPage = records.length === this.state.pageSize; // If we got full page, assume there's more

            this.setState({
                leadsListResult: records,
                loading: false,
                currentPage: page,
                hasNextPage: hasNextPage
            });

        } catch (error) {
            console.error("Search failed:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    render() {
        if (
            this.props.location.search.includes("?_tab=demographics") ||
            this.props.location.search.includes("?_tab=conditions") ||
            this.props.location.search.includes("?_tab=tags")
        ) {
            const searchParams = new URLSearchParams(this.props.location.search);
            searchParams.delete("_resource");
            const cleanSearch = searchParams.toString() ? `?${searchParams.toString()}` : '';

            this.props.router.navigate(`/patient-list${cleanSearch}`);
            return null;
        }

        return (
            <div className="page">
                <div className="app-header">
                    <Header2
                        query={this.props.query}
                        settings={this.props.settings}
                        location={this.props.location}
                        urlParams={this.props.urlParams}
                    />

                    <ViewHeader
                        query={this.props.query}
                        settings={this.props.settings}
                        location={this.props.location}
                        urlParams={this.props.urlParams}
                        activeTab={this.state.activeTab}
                        onTabChange={this.handleTabChange}
                    />
                </div>

                <div className="patient-search-results">
                    {this.renderTabContent()}
                </div>
            </div>
        )
    }

    renderTabContent() {
        const { activeTab } = this.state;

        switch (activeTab) {
            case "patients":
                return this.renderPatientsContent();
            case "diagnosis":
                return this.renderDiagnosisContent();
            case "allergy":
                return this.renderAllergyContent();
            case "leads":
                return this.renderLeadsContent();
            default:
                return this.renderPatientsContent();
        }
    }

    // Add this method to your Patients component
    handlePatientClick = (patient) => {
        this.setState({ selectedPatient: patient });
    }
    handleAllergyClick = (allergy) => {
        console.log("Allergy clicked:", allergy);
        this.setState({ selectedAllergy: allergy });
    }
    handleDiagnosisClick = (diagnosis) => {
        console.log("diagnosis clicked:", diagnosis);
        this.setState({ selectedDiagnosis: diagnosis });
    }

    renderPatientsContent() {
        const { loading, error, patientListResult, currentPage, hasNextPage, pageSize } = this.state;

        if (loading) {
            return <div className="patient-search-loading">
                <i className="fa fa-spinner spin" /> Loading. Please wait...
            </div>;
        }

        if (error) {
            return <p className="text-danger">Error: {error}</p>;
        }

        if (!patientListResult || patientListResult.length === 0) {
            return (
                <>
                    <div className="panel-default">
                        <div className="panel-heading" style={{ padding: "5px 15px" }}>
                            <div className="row d-flex align-items-center">
                                <div className="col-xs-6">
                                    <b className="text-primary">
                                        <i className="fa fa-address-card-o" /> Patients
                                    </b>
                                </div>
                                <div className="col-xs-6">
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control input-sm"
                                                    placeholder="Search by MRN..."
                                                    value={this.state.patientSearchTerm}
                                                    onChange={(e) => this.setState({ patientSearchTerm: e.target.value })}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.fetchPatientData(1);
                                                        }
                                                    }}
                                                />
                                                <span className="input-group-btn">
                                                    <button
                                                        className="btn btn-primary btn-sm"
                                                        onClick={() => this.fetchPatientData(1)}
                                                    >
                                                        <small>
                                                            <i className="fa fa-search" />
                                                        </small>
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p>No patient data available.</p>
                </>
            );
        }

        const hasPrev = currentPage > 1;
        const hasNext = hasNextPage;

        const searchHeader = (
            <div className="panel-default">
                <div className="panel-heading" style={{ padding: "5px 15px" }}>
                    <div className="row d-flex align-items-center">
                        <div className="col-xs-4">
                            <b className="text-primary">
                                <i className="fa fa-address-card-o" /> Patients
                            </b>
                        </div>
                        <div className="col-xs-4 text-center">
                            {/* <div className="form-inline">
                                <label className="mr-2">Show:</label>
                                <select
                                    className="form-control input-sm"
                                    value={pageSize}
                                    onChange={this.handlePageSizeChange}
                                    style={{ width: '70px' }}
                                >
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                                <label className="ml-2">per page</label>
                            </div> */}
                        </div>
                        <div className="col-xs-4">
                            <div className="row">
                                <div className="col-md-8 pull-right">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            placeholder="Search by MRN..."
                                            value={this.state.patientSearchTerm}
                                            onChange={(e) => this.setState({ patientSearchTerm: e.target.value })}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    this.fetchPatientData(1);
                                                }
                                            }}
                                        />
                                        <span className="input-group-btn">
                                            <button
                                                className="btn btn-primary btn-sm"
                                                onClick={() => this.fetchPatientData(1)}
                                            >
                                                <i className="fa fa-search" />
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <>
                <div className="tab-content-wrapper" style={{ marginBottom: "2.5rem" }}>
                    {searchHeader}
                    {patientListResult.map((o, i) => (
                        <PatientItem
                            {...o}
                            key={o.messageID}
                            index={i}
                            query={this.props.query}
                            settings={this.props.settings}
                            onClick={() => this.handlePatientClick(o)}
                        />
                    ))}

                    {/* Sidebar */}
                    {this.state.selectedPatient && (
                        <PatientSidebar
                            patient={this.state.selectedPatient}
                            isOpen={!!this.state.selectedPatient}
                            onClose={() => this.setState({ selectedPatient: null })}
                            settings={this.props.settings}
                        />
                    )}
                </div>

                {/* Footer with Pagination */}
                <div className="app-footer" style={{ position: "fixed", bottom: 0, width: "100%", backgroundColor: "#f5f5f5", borderTop: "1px solid #ddd" }}>
                    <div className="container-fluid" style={{ width: "100%" }}>
                        <div className="row">
                            <div className="col-xs-3 col-sm-4 text-right">
                                <a
                                    href="#prev"
                                    onClick={e => {
                                        e.preventDefault();
                                        if (hasPrev) this.handlePrevPage();
                                    }}
                                    style={{
                                        color: hasPrev ? '#007bff' : '#6c757d',
                                        cursor: hasPrev ? 'pointer' : 'not-allowed',
                                        textDecoration: 'none'
                                    }}
                                >
                                    <i className="fa fa-arrow-left" /> Prev
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-4 text-center">
                                <span className="pagination-status">
                                    Page {currentPage}
                                </span>
                            </div>
                            <div className="col-xs-3 col-sm-4 text-left">
                                <a
                                    href="#next"
                                    onClick={e => {
                                        e.preventDefault();
                                        if (hasNext) this.handleNextPage();
                                    }}
                                    style={{
                                        color: hasNext ? '#007bff' : '#6c757d',
                                        cursor: hasNext ? 'pointer' : 'not-allowed',
                                        textDecoration: 'none'
                                    }}
                                >
                                    Next <i className="fa fa-arrow-right" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    renderDiagnosisContent() {
        const { loading, error, diagnosisListResult } = this.state;

        if (loading) {
            return <div className="patient-search-loading">
                <i className="fa fa-spinner spin" /> Loading. Please wait...
            </div>;
        }

        if (error) {
            return <p className="text-danger">Error: {error}</p>;
        }

        if (!diagnosisListResult || diagnosisListResult.length === 0) {
            return <p>No data available.</p>;
        }

        // Define your search/filter UI in the parent
        const searchHeader = (

            <div className="col-xs-6">
                <div className="row">
                    <div className="col-md-5 pull-right">
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control input-sm"
                                placeholder="Search by code..."
                                value={this.state.diagnosisSearchTerm}
                                onChange={(e) => this.setState({ diagnosisSearchTerm: e.target.value })}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        this.fetchDiagnosisData();
                                    }
                                }}
                            />
                            <span className="input-group-btn">
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={this.fetchDiagnosisData}
                                >
                                    <small>
                                        <i className="fa fa-search" />
                                    </small>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <div className="tab-content-wrapper">
                <Grid
                    rows={diagnosisListResult}
                    title="Diagnosis"
                    cols={[
                        {
                            label: "Code",
                            path: "diagnosisCode"
                        },
                        {
                            label: "Description",
                            path: "diagnosisDescription"
                        },
                        {
                            label: "CodeSystem",
                            path: "diagnosisCodeSystem"
                        }
                    ]}
                    headerContent={searchHeader} // Pass the custom header
                    isLoading={loading} // Pass loading state
                    onClick={(o) => this.handleDiagnosisClick(o)}
                />

                {/* Sidebar */}
                {this.state.selectedDiagnosis && (
                    <DiagnosisSidebar
                        diagnosis={this.state.selectedDiagnosis}
                        isOpen={!!this.state.selectedDiagnosis}
                        onClose={() => this.setState({ selectedDiagnosis: null })}
                        settings={this.props.settings}
                    />
                )}
            </div>
        );
    }

    renderAllergyContent() {
        const { loading, error, allergyListResult } = this.state;

        if (loading) {
            return <div className="patient-search-loading">
                <i className="fa fa-spinner spin" /> Loading. Please wait...
            </div>;
        }

        if (error) {
            return <p className="text-danger">Error: {error}</p>;
        }

        if (!allergyListResult || allergyListResult.length === 0) {
            return <p>No data available.</p>;
        }

        // Define your search/filter UI in the parent
        const searchHeader = (

            <div className="col-xs-6">
                <div className="row">
                    <div className="col-md-5 pull-right">
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control input-sm"
                                placeholder="Search by code..."
                                value={this.state.allergySearchTerm}
                                onChange={(e) =>
                                    this.setState({ allergySearchTerm: e.target.value })
                                }
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        this.fetchAllergyData();
                                    }
                                }}
                            />
                            <span className="input-group-btn">
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={this.fetchAllergyData}
                                >
                                    <small>
                                        <i className="fa fa-search" />
                                    </small>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <div className="tab-content-wrapper">
                <Grid
                    rows={(this.state.allergyListResult || [])}
                    title="Allergy"
                    cols={[
                        {
                            label: "Code",
                            path: "allergyCode"
                        },
                        {
                            label: "Description",
                            path: "allergyDescription"
                        },
                        {
                            label: "CodeSystem",
                            path: "allergyCodeSystem"
                        }
                    ]}
                    headerContent={searchHeader} // Pass the custom header
                    isLoading={loading} // Pass loading state
                    onClick={(o) => this.handleAllergyClick(o)}
                />

                {/* Sidebar */}
                {this.state.selectedAllergy && (
                    <AllergySidebar
                        allergy={this.state.selectedAllergy}
                        isOpen={!!this.state.selectedAllergy}
                        onClose={() => this.setState({ selectedAllergy: null })}
                        settings={this.props.settings}
                    />
                )}
            </div>
        );
    }

    renderCell(record, allOf, oneOf) {
        const entries = [];

        const visit = meta => {
            let propValue = getPath(record, meta.path);
            if (propValue !== undefined) {
                let value = meta.render ? meta.render(record) : propValue;
                let raw = meta.raw ? meta.raw(record) : value;
                let label = typeof meta.label == "function" ? meta.label(record) : meta.label;
                let existing = entries.find(o => o.value === raw);
                if (existing) {
                    existing.label += ", " + label
                }
                else {
                    entries.push({ label, value });
                }
                return true;
            }
            return false;
        };

        allOf.forEach(visit);

        if (!entries.length) {
            oneOf.some(visit);
        }

        if (entries.length) {
            return (
                <table>
                    <tbody>
                        {
                            entries.map((o, i) => (
                                <tr key={i}>
                                    <td className="label-cell">{o.label}</td>
                                    <td>{o.value}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            );
        }

        return "-"
    }

    renderLeadsContent() {
        const { loading, error, leadsListResult, currentPage, hasNextPage, pageSize } = this.state;

        if (loading) {
            return <div className="patient-search-loading">
                <i className="fa fa-spinner spin" /> Loading. Please wait...
            </div>;
        }

        if (error) {
            return <p className="text-danger">Error: {error}</p>;
        }

        if (!leadsListResult || leadsListResult.length === 0) {
            return <p>No data available.</p>;
        }

        const hasPrev = currentPage > 1;
        const hasNext = hasNextPage;

        return (
            <>
                <div className="tab-content-wrapper patient-view-page">
                    <Grid
                        rows={(this.state.leadsListResult || [])}
                        title="Leads"
                        cols={[
                            // Group: Name
                            {
                                label: "Name",
                                render: o => this.renderCell(o, [
                                    {
                                        label: "First Name",
                                        path: "Member_First_Name"
                                    },
                                    {
                                        label: "Last Name",
                                        path: "Member_Last_Name",
                                        render: rec => rec.Member_Last_Name?.trim() // remove trailing spaces
                                    }
                                ])
                            },

                            // Group: Contact Info
                            {
                                label: "Contact Info",
                                render: o => this.renderCell(o, [
                                    {
                                        label: "Phone Number",
                                        path: "Member_PhoneNumber"
                                    },
                                    {
                                        label: "Address",
                                        path: "Member_Address",
                                    },
                                    {
                                        label: "County",
                                        path: "County"
                                    }
                                ])
                            },

                            // Group: Identification
                            {
                                label: "Identification",
                                render: o => this.renderCell(o, [
                                    {
                                        label: "CIN",
                                        path: "Member_CIN"
                                    },
                                    {
                                        label: "Secondary ID",
                                        path: "Member_Secondary_id"
                                    },
                                    {
                                        label: "Report Year/Month",
                                        path: "Report_Year_Month"
                                    }
                                ])
                            },

                            // Group: PCP Information
                            {
                                label: "PCP Details",
                                render: o => this.renderCell(o, [
                                    {
                                        label: "PCP Name",
                                        path: "PCPName"
                                    },
                                    {
                                        label: "PCP Group ID",
                                        path: "PCPGroupID"
                                    },
                                    {
                                        label: "PCP Group Phone",
                                        path: "PCP_Group_Phone_No"
                                    }
                                ])
                            },

                            // Group: Demographics
                            {
                                label: "Demographics",
                                render: o => this.renderCell(o, [
                                    {
                                        label: "Gender",
                                        path: "Member_Gender"
                                    },
                                    {
                                        label: "Spoken Language",
                                        path: "MemberSpokenLanguageName"
                                    }
                                ])
                            },

                            // Group: Status Flags
                            {
                                label: "Status Flags",
                                render: o => this.renderCell(o, [
                                    {
                                        label: "Adult Experiencing Homelessness",
                                        path: "Adult_Experiencing_Homelessness",
                                    },
                                    {
                                        label: "Child Experiencing Homelessness",
                                        path: "Child_Experiencing_Homelessness",
                                    },
                                    {
                                        label: "Foster Care",
                                        path: "Foster_Care",
                                    },
                                    {
                                        label: "Adult Birth Equity",
                                        path: "Adult_Birth_Equity",
                                    },
                                    {
                                        label: "Child Birth Equity",
                                        path: "Child_Birth_Equity",
                                    },
                                    {
                                        label: "Adult High Utilizer",
                                        path: "Adult_High_Utilizer",
                                    },
                                    {
                                        label: "Child High Utilizer",
                                        path: "Child_High_utilizer",
                                    },
                                    {
                                        label: "Youth Enrolled in CCS",
                                        path: "Youth_Enrolled_in_CCS",
                                    }
                                ])
                            }
                        ]}
                    />
                </div>

                {/* Footer with Pagination */}
                <div className="app-footer" style={{ position: "fixed", bottom: 0, width: "100%", backgroundColor: "#f5f5f5", borderTop: "1px solid #ddd" }}>
                    <div className="container-fluid" style={{ width: "100%" }}>
                        <div className="row">
                            <div className="col-xs-3 col-sm-4 text-right">
                                <a
                                    href="#prev"
                                    onClick={e => {
                                        e.preventDefault();
                                        if (hasPrev) this.handlePrevPage();
                                    }}
                                    style={{
                                        color: hasPrev ? '#007bff' : '#6c757d',
                                        cursor: hasPrev ? 'pointer' : 'not-allowed',
                                        textDecoration: 'none'
                                    }}
                                >
                                    <i className="fa fa-arrow-left" /> Prev
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-4 text-center">
                                <span className="pagination-status">
                                    Page {currentPage}
                                </span>
                            </div>
                            <div className="col-xs-3 col-sm-4 text-left">
                                <a
                                    href="#next"
                                    onClick={e => {
                                        e.preventDefault();
                                        if (hasNext) this.handleNextPage();
                                    }}
                                    style={{
                                        color: hasNext ? '#007bff' : '#6c757d',
                                        cursor: hasNext ? 'pointer' : 'not-allowed',
                                        textDecoration: 'none'
                                    }}
                                >
                                    Next <i className="fa fa-arrow-right" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

}

export default connect(state => state)(withRouter(Patients));